export class InvestmentFinancialConst {
  public static headerTable = [
    { field: 'accountingModelsNumber', title: 'Cuenta contable', cell: (row) => row.accountingModelsNumber ? `${row.accountingModelsNumber}` : '', class: (row) => `` },
    { field: 'investmentValue', title: 'Valor de la inversión', cell: (row) => row.investmentValue ? `${row.investmentValue}` : '', class: (row) => `` },
    {
      field: 'investmentDate', title: 'Fecha inversión', cell: (row) =>
      row.investmentDate ? `${new Date(row.investmentDate).toLocaleDateString()}` : '', class: (row) => ``
    },
    { field: 'netBookValue', title: 'Valor neto contable', cell: (row) => row.netBookValue ? `${row.netBookValue}` : '0.00', class: (row) => `` },
    {
      field: 'paided', title: 'Pagado', cell: (row) =>
        row.paided != 0 ? `${ isNaN(Date.parse(row.paided)) ? row.paided : new Date(row.paided).toLocaleDateString()}` : '0.00', class: (row) => ``
    },
  ];
}
